export default "__VITE_ASSET__250464cf__"